// extracted by mini-css-extract-plugin
export default {"skill_list":"SkillList_skill_list__bmG5P","skill_wrapper":"SkillList_skill_wrapper__RaR8k","main_skill":"SkillList_main_skill__oT-22"};